import React,{useState} from 'react';
import {
    Collapse,Navbar,NavbarToggler,NavbarBrand,Nav,
    UncontrolledDropdown,DropdownToggle,
    DropdownMenu,DropdownItem,NavbarText,
    } from 'reactstrap';
import logo from '../../../assets/images/logo.png';
import {ADMIN_PROFILE_PATH} from '../../../utils/AppRoutes';
import { Link, useHistory } from 'react-router-dom';
import defaultAvatar from '../../../assets/images/defaultImages/defaultAvatar.png';
import { logout } from '../../../utils/functions/CoreFunctions';
import { getConfirm, getCurrentUserName, getCurrentProfile } from '../../../utils/functions/CustomFunctions';
import Swal from 'sweetalert2';
import { LOCALSTORAGE_AUTH_USER } from '../../../utils/constants/LocalStorage';

const AdminHeader = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const history = useHistory();

    const logoutClick = () => {
        Swal.fire(
           getConfirm('warning', 'Are you sure you want to sign out?')
        )
        .then(result => 
        {
            if (result.value) {
                logout(history);
            }
        });  
    }

    let userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_USER));

    return (
        <Navbar fixed='top' color='light' light expand='md' className='navbar-bg'>
            <NavbarBrand href='/'><img src={logo}  /></NavbarBrand>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className='mr-auto' navbar></Nav>
                <NavbarText>
                    <UncontrolledDropdown nav inNavbar className='nav-dropdown'>
                        <DropdownToggle nav caret>
                            <img className='UserImg' src={getCurrentProfile() || defaultAvatar} />
                            {/* <span>Natosha Jacobs</span> */}
                        </DropdownToggle>
                        <DropdownMenu right>
                            <DropdownItem>
                                <img className='dropdown-userImg' src={getCurrentProfile() || defaultAvatar} />
                                <h6 className='text-center'>{getCurrentUserName()}</h6>
                                <p className='text-center'>Paygov Admin</p>
                            </DropdownItem>
                            <Link to={ADMIN_PROFILE_PATH}>
                            <DropdownItem style={{cursor:'pointer'}}>
                                    My Profile 
                            </DropdownItem>
                            </Link>
                            <DropdownItem />                         
                            <DropdownItem onClick={logoutClick} style={{cursor:'pointer'}}>
                                     Sign Out
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </NavbarText>
            </Collapse>
        </Navbar>
    );
}
export default AdminHeader;